/*
 * @Author: YuanYuan
 * @Date: 2024-08-16 11:03:20
 * @LastEditTime: 2026-01-30 14:16:25
 * @Description: axios实例配置
 */
import axios from 'axios'
import Cookies from 'js-cookie'
import { lang } from '@/i18n'
import $store from '@/store'
import { getCurrentGoodsCode } from '@/utils/base'

import {
  responseInterceptorFailed,
  responseInterceptorSucceed
} from './interceptor'

const axiosInstance = axios.create({
  timeout: 300000,
  baseURL: '',
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'X-Lang': lang,
    'X-Cms-Token': '',
    'X-Switch-User': '',
    'Goods-Code': ''
  }
})

axiosInstance.interceptors.request.use(config => {
  config.headers['X-Cms-Token'] = Cookies.get('X-Cms-Token')
  config.headers['X-Switch-User'] = $store.state.csec.userSwitch
  config.headers['Goods-Code'] = getCurrentGoodsCode()
  return config
}, error => {
  console.warn(new Error(`axiosInstance.interceptors.request: ${error}`))
})

axiosInstance.interceptors.response.use(response => {
  return responseInterceptorSucceed(response)
}, error => {
  responseInterceptorFailed(error)
})

export default axiosInstance